import {BoxProps} from '@material-ui/core/Box';
import React from 'react';
import {MenuItem, Select, SelectProps} from '@material-ui/core';

import {StackProps} from '../../layout/layout.styled';
import {FormControl} from '../form-control/form-control.styles';
import {ArrowDownIcon} from './arrow-down-icon';

export type SelectFormControlProps = {
    labelText: string
    'data-testid'?: string
    labelProps?: BoxProps
    stackProps?: StackProps
    selectProps?: SelectProps
    menuItems: Array<MenuItem>
}

export type MenuItem = {
    labelText: string
    value: string
}

export const SelectFormControl = ({
    'data-testid': dataTestId = 'SelectFormControl',
    labelText,
    labelProps,
    stackProps,
    selectProps,
    menuItems = []
}: SelectFormControlProps) => {
    return (
        <FormControl
            data-testid={dataTestId}
            labelText={labelText}
            labelProps={labelProps}
            {...stackProps}
        >
            <Select
                variant={'outlined'}
                IconComponent={ArrowDownIcon}
                {...selectProps}
            >
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>

                {menuItems.map((item, index) => (
                    <MenuItem
                        key={`${labelText}-${index}-${item.value}`}
                        value={item.value}
                    >
                        {item.labelText}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
